import React, { useMemo, useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import logo from "../../assets/mm-logo.png"
import rosPhoto from "../../assets/Ros.png"

const BROKER_USERS = {
  leah_associate: {
    password: "associate_leah01!",
    profile: {
      branchKey: "leah",
      virtualBranch: "leah",
      tokenKey: "leah",
      branchScope: "broker",
      brokerPersonId: "",
      brokerCA: "",
      branchName: "Leah Roselle Pader",
      role: "associate",
      username: "leah_associate",
      photo: rosPhoto,
    },
  },

  baljot_broker: {
    password: "baljot01!",
    profile: {
      branchKey: "baljot",
      virtualBranch: "baljot",
      tokenKey: "baljot",
      branchScope: "broker",
      brokerPersonId: "a9f12585-448d-4bf5-a5f0-51d7c0235955",
      brokerCA: "CA109699",
      branchName: "Baljot Sekhon",
      role: "broker",
      username: "baljot_broker",
      photo: "",
    },
  },

  maggie_broker: {
    password: "maggie01!",
    profile: {
      branchKey: "maggie",
      virtualBranch: "maggie",
      tokenKey: "maggie",
      branchScope: "broker",
      brokerPersonId: "",
      brokerCA: "",
      branchName: "Maggie Ma",
      role: "broker",
      username: "maggie_broker",
      photo: "",
    },
  },

  tatenda_broker: {
    password: "tatenda01!",
    profile: {
      branchKey: "tatenda",
      virtualBranch: "tatenda",
      tokenKey: "tatenda",
      branchScope: "broker",
      brokerPersonId: "",
      brokerCA: "",
      branchName: "Tatenda Chauraya",
      role: "broker",
      username: "tatenda_broker",
      photo: "",
    },
  },

  cynthia_broker: {
    password: "cynthia01!",
    profile: {
      branchKey: "cynthia",
      virtualBranch: "cynthia",
      tokenKey: "cynthia",
      branchScope: "broker",
      brokerPersonId: "",
      brokerCA: "",
      branchName: "Cynthia",
      role: "broker",
      username: "cynthia_broker",
      photo: "",
    },
  },

  sailesh_broker: {
    password: "sailesh01!",
    profile: {
      branchKey: "sailesh",
      virtualBranch: "sailesh",
      tokenKey: "sailesh",
      branchScope: "broker",
      brokerPersonId: "",
      brokerCA: "",
      branchName: "Sailesh Balendran",
      role: "broker",
      username: "sailesh_broker",
      photo: "",
    },
  },

  admin: {
    password: "admin01!",
    profile: {
      branchKey: "",
      virtualBranch: "",
      tokenKey: "",
      branchScope: "admin",
      brokerPersonId: "",
      brokerCA: "",
      branchName: "Mortgage Matrix",
      role: "admin",
      username: "admin",
      photo: "",
    },
  },
}

const STORAGE_KEY = "mmBrokerProfile"
const SESSION_EXPIRY_KEY = "mmBrokerProfileExpiry"
const SESSION_DURATION_MS = 6 * 60 * 60 * 1000

function buildCRMUrl(profile = {}, existingSearch = "") {
  const params = new URLSearchParams(existingSearch)

  if (profile.branchKey) params.set("branchKey", profile.branchKey)
  if (profile.virtualBranch) params.set("virtualBranch", profile.virtualBranch)
  if (profile.tokenKey) params.set("tokenKey", profile.tokenKey)
  if (profile.branchScope) params.set("branchScope", profile.branchScope)
  if (profile.brokerPersonId) params.set("brokerPersonId", profile.brokerPersonId)
  if (profile.brokerCA) params.set("brokerCA", profile.brokerCA)
  if (profile.branchName) params.set("branchName", profile.branchName)

  const qs = params.toString()
  return qs ? `/crm?${qs}` : "/crm"
}

export default function Login() {
  const navigate = useNavigate()
  const location = useLocation()

  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")

  useEffect(() => {
    try {
      const savedProfileRaw = localStorage.getItem(STORAGE_KEY)
      const savedExpiryRaw = localStorage.getItem(SESSION_EXPIRY_KEY)

      if (!savedProfileRaw || !savedExpiryRaw) return

      const expiry = Number(savedExpiryRaw)
      const now = Date.now()

      if (!Number.isFinite(expiry) || now >= expiry) {
        localStorage.removeItem(STORAGE_KEY)
        localStorage.removeItem(SESSION_EXPIRY_KEY)
        return
      }

      const savedProfile = JSON.parse(savedProfileRaw)
      navigate(buildCRMUrl(savedProfile, location.search), { replace: true })
    } catch (err) {
      localStorage.removeItem(STORAGE_KEY)
      localStorage.removeItem(SESSION_EXPIRY_KEY)
    }
  }, [navigate, location.search])

  const styles = useMemo(
    () => ({
      page: {
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(180deg, #f8fdff 0%, #eefcff 100%)",
        padding: 20,
      },

      card: {
        width: "100%",
        maxWidth: 420,
        background: "#fff",
        borderRadius: 24,
        padding: 30,
        boxShadow: "0 24px 60px rgba(0,0,0,0.10)",
        border: "1px solid rgba(20,20,20,0.08)",
      },

      logoWrap: {
        display: "flex",
        justifyContent: "center",
        marginBottom: 12,
      },

      logoImg: {
        width: 260,
        height: "auto",
      },

      divider: {
        width: 80,
        height: 4,
        background: "#4EDCF6",
        borderRadius: 3,
        margin: "12px auto 18px auto",
      },

      subtitle: {
        textAlign: "center",
        fontSize: 16,
        color: "rgba(20,20,20,0.7)",
        marginBottom: 22,
        fontWeight: 500,
      },

      label: {
        display: "block",
        fontSize: 13,
        fontWeight: 700,
        color: "#141414",
        marginBottom: 8,
      },

      input: {
        width: "100%",
        height: 48,
        borderRadius: 14,
        border: "2px solid #dbe4ea",
        padding: "0 14px",
        fontSize: 15,
        outline: "none",
        marginBottom: 14,
        boxSizing: "border-box",
      },

      button: {
        width: "100%",
        height: 50,
        borderRadius: 14,
        border: "none",
        background: "#4EDCF6",
        color: "#141414",
        fontSize: 15,
        fontWeight: 800,
        cursor: "pointer",
        marginTop: 6,
      },

      error: {
        marginTop: 12,
        fontSize: 13,
        color: "#d11a2a",
        fontWeight: 600,
      },

      hint: {
        marginTop: 16,
        fontSize: 12,
        color: "rgba(20,20,20,0.55)",
        lineHeight: 1.5,
        textAlign: "center",
      },
    }),
    []
  )

  const handleLogin = (e) => {
    e.preventDefault()
    setError("")

    const key = String(username || "").trim().toLowerCase()
    const entry = BROKER_USERS[key]

    if (!entry) {
      setError("Username not found.")
      return
    }

    if (String(password || "") !== entry.password) {
      setError("Incorrect password.")
      return
    }

    try {
      const expiry = Date.now() + SESSION_DURATION_MS
      localStorage.setItem(STORAGE_KEY, JSON.stringify(entry.profile))
      localStorage.setItem(SESSION_EXPIRY_KEY, String(expiry))
      navigate(buildCRMUrl(entry.profile, location.search), { replace: true })
    } catch (err) {
      setError("Unable to save login session.")
    }
  }

  return (
    <div style={styles.page}>
      <form style={styles.card} onSubmit={handleLogin}>
        <div style={styles.logoWrap}>
          <img src={logo} alt="Mortgage Matrix" style={styles.logoImg} />
        </div>

        <div style={styles.divider} />

        <div style={styles.subtitle}>Broker CRM Login</div>

        <label style={styles.label}>Username</label>
        <input
          style={styles.input}
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Enter username"
          autoComplete="username"
        />

        <label style={styles.label}>Password</label>
        <input
          style={styles.input}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter password"
          autoComplete="current-password"
        />

        <button type="submit" style={styles.button}>
          Log In
        </button>

        {error && <div style={styles.error}>{error}</div>}

        <div style={styles.hint}>
          Login will be remembered for 6 hours on this browser.
        </div>
      </form>
    </div>
  )
}